import React from 'react';
import './WhatsAppButton.css';

const WhatsAppButton = ({ phoneNumber }) => {
    const whatsappLink = `https://wa.me/${phoneNumber}`;
    
    return (
        <a 
            href={whatsappLink}
            className="floating-whatsapp"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Contactez-nous sur WhatsApp"
        >
            <i className="bi bi-whatsapp"></i>
            <span className="tooltip">Contactez-nous</span>
        </a>
    );
};

export default WhatsAppButton;